// extracted by mini-css-extract-plugin
export default {"selectionIndicator":"SelectionIndicator_selectionIndicator__GB4aI","checked":"SelectionIndicator_checked__Hcpzk"};